export default __webpack_public_path__ + "6f976970c28ca340bb456e5bd7cba665.jpg";